export default "__VITE_ASSET__2e70a41d__"